module.exports = __webpack_public_path__ + "img/bangaloreDark.3b165642.png";